import { render, staticRenderFns } from "./DownloadsPage.vue?vue&type=template&id=0eab1bb8&scoped=true&"
import script from "./DownloadsPage.vue?vue&type=script&lang=ts&"
export * from "./DownloadsPage.vue?vue&type=script&lang=ts&"
import style0 from "./DownloadsPage.vue?vue&type=style&index=0&id=0eab1bb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eab1bb8",
  null
  
)

export default component.exports